import React, { useState, useCallback } from 'react';
import { debounce, noop } from 'lodash';
import { string, func } from 'prop-types';
import { Input } from '@fiverr-private/fit';
import { I18n, translate } from '@fiverr-private/i18n-react';
import {
    VARIATIONS_TOOLBAR_FIELD_DEBOUNCE,
    BRAND_NAME_MAXLENGTH,
    SLOGAN_MAXLENGTH,
} from '../../../../../shared/constants';
import { TRACKING_ELEMENT_NAME } from './constants';
import './style.scss';

const VariationsToolBar = ({ brandName: initialBrandName, slogan: initialSlogan, onChange = noop }) => {
    const [brandName, setBrandName] = useState(initialBrandName);
    const [slogan, setSlogan] = useState(initialSlogan);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedChange = useCallback(
        debounce((change, metaFields) => {
            onChange(change, metaFields);
        }, VARIATIONS_TOOLBAR_FIELD_DEBOUNCE),
        []
    );

    const onBrandNameChange = ({ target: { value } }, label) => {
        setBrandName(value);

        if (!!value && value.trim().length) {
            debouncedChange({ brandName: value, slogan }, { name: TRACKING_ELEMENT_NAME.BRAND, label });
        }
    };

    const onSloganChange = ({ target: { value } }, label) => {
        setSlogan(value);
        debouncedChange({ slogan: value, brandName }, { name: TRACKING_ELEMENT_NAME.SLOGAN, label });
    };

    const inputProps = {
        autoComplete: 'off',
        'data-lpignore': true,
    };

    return (
        <div className="variations-toolbar">
            <div className="form-group">
                <label htmlFor="brandName">
                    <I18n k="logo_maker_perseus.general.brand_name" />
                </label>
                <Input
                    name="brandName"
                    id="brandName"
                    {...inputProps}
                    value={brandName}
                    onChange={(e) => onBrandNameChange(e, translate('logo_maker_perseus.general.brand_name'))}
                    maxLength={BRAND_NAME_MAXLENGTH}
                />
            </div>
            <div className="form-group">
                <label htmlFor="slogan">
                    <I18n k="logo_maker_perseus.general.slogan" />
                </label>
                <Input
                    name="slogan"
                    {...inputProps}
                    id="slogan"
                    value={slogan}
                    placeholder={translate('logo_maker_perseus.general.slogan_placeholder')}
                    onChange={(e) => onSloganChange(e, translate('logo_maker_perseus.general.slogan'))}
                    maxLength={SLOGAN_MAXLENGTH}
                />
            </div>
        </div>
    );
};

VariationsToolBar.propTypes = {
    onChange: func,
    brandName: string,
    slogan: string,
};

export default VariationsToolBar;
